export const SEND_QUERY_SUCCESS = "landing/SEND_QUERY_SUCCESS"
export const SEND_QUERY_FAILURE = "landing/SEND_QUERY_FAILURE"